import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonToolbar,
  Form,
  Loader,
  Container,
  Content,
  Checkbox,
  Modal,
  Row,
  Col,
} from "rsuite";
import { OrderServices } from "../../../core/services/OrderServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import "./Orders.css";
import { useSelector } from "react-redux";
import {
  onOffArr,
  orderStatusObj,
  serviceRatingArr,
  serviceRatingObjArr,
} from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import {
  displayDateField,
  displayDateTimeField,
  displayField,
  displayTimeField,
  isEmptyVal,
  isNotEmpty,
  processMinute,
} from "../../../utils/helpers";
import { get } from "lodash/fp";

const ViewOrder = (props: any) => {
  const { t } = useTranslation();
  const orderActionData = useSelector((state: any) => {
    return state?.actionData?.id;
  });
  const [loader, setLoader] = useState(false);
  const [orderInfo, setOrderInfo] = useState<any>({});
  const [custAddress, setCustAddress] = useState<any>({});

  async function getViewOrderDetail(id: number) {
    try {
      setLoader(true);
      const res = await OrderServices.viewOrder(id);
      const orderData = get("data.data", res);
      setLoader(false);
      if (orderData) {
        setOrderInfo({ ...orderData });
        if (orderData?.customer?.addresses.length) {
          orderData?.customer?.addresses.map((item: any) => {
            if (item?.is_primary_address === "1") {
              setCustAddress(item);
            }
          });
        }
      }
    } catch (error) {
      setLoader(false);
    }
  }
  useEffect(() => {
    let orderId = orderActionData;
    getViewOrderDetail(orderId);
  }, []);

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Modal
        open={props.status}
        backdrop={false}
        onClose={(e: any) => {
          props.toggle("");
        }}
        size="md"
      >
        <Modal.Header>
          <h4 className="text-center">
            {t("VIEW")} {t("ORDER")} {t("DETAIL")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="orders view-orders">
            <Container className="container">
              {orderInfo && Object.keys(orderInfo).length ? (
                <Content>
                  <div className="address pt-0">
                    <div className="view-usr-profile text-center mb-3">
                      <div>
                        <img
                          src={
                            orderInfo && orderInfo?.customer?.image_url
                              ? orderInfo?.customer?.image_url
                              : UtilityServices.getLoggedInUser(
                                  "user_default_image"
                                )
                          }
                          alt=""
                        />
                      </div>
                    </div>
                    <Row>
                      <Col className="address-col">
                        {t("CUSTOMER")} {t("NAME")} :
                        <label>
                          {displayField(`${orderInfo?.customer?.name}`)}
                        </label>
                      </Col>
                      <Col className="address-col">
                        {t("MOBILE")} :
                        <label>
                          {displayField(`${orderInfo?.customer?.mobile}`)}
                        </label>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="address-col">
                        {t("EMAIL")} :
                        <label>
                          {displayField(`${orderInfo?.customer?.email}`)}
                        </label>
                      </Col>
                      <Col className="address-col">
                        {t("HOUSE_NO")} :
                        <label>
                          {displayField(`${custAddress?.house_no}`)}
                        </label>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="address-col">
                        {t("BUILDING")} :
                        <label>
                          {displayField(`${custAddress?.building_name}`)}
                        </label>
                      </Col>
                      <Col className="address-col">
                        {t("LANDMARK")} :
                        <label>
                          {displayField(`${custAddress?.landmark}`)}
                        </label>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="address-col">
                        {t("AREA")} :
                        <label>
                          {displayField(`${custAddress?.area_name}`)}
                        </label>
                      </Col>
                      <Col className="address-col">
                        {t("PINCODE")} :
                        <label>{displayField(`${custAddress?.pincode}`)}</label>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="address-col">
                        {t("CITY")} :
                        <label>
                          {displayField(`${custAddress?.city?.city_name}`)}
                        </label>
                      </Col>
                      <Col className="address-col">
                        {t("STATE")} :
                        <label>
                          {displayField(`${custAddress?.state?.state_name}`)} (
                          {displayField(
                            `${custAddress?.country?.country_name}`
                          )}
                          )
                        </label>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="address-col">
                        {t("BOOKED")} {t("FOR")} {t("STORE")} :
                        <label>
                          {displayField(`${orderInfo?.store?.store_name}`)}(
                          {displayField(`${orderInfo?.store?.area_name}`)},{" "}
                          {displayField(`${orderInfo?.store?.city?.city_name}`)}
                          )
                        </label>
                      </Col>
                      <Col className="address-col">
                        {t("SERVE")} {t("ORDER")} {t("AT")} :
                        <label>
                          {displayField(`${orderInfo?.order_serve_at}`)}
                        </label>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="address-col mb-col-50">
                        <label>
                          <b>{t("ITEM") + " " + t("NAME")}</b>
                        </label>
                      </Col>
                      <Col className="address-col mb-col-50">
                        <label>
                          <b>{t("PRICE")}</b>
                        </label>
                      </Col>
                    </Row>
                    {orderInfo?.order_items.map((item: any, index: number) => {
                      return (
                        <Row>
                          <Col className="address-col mb-col-50">
                            <label>{item.product_name}</label>
                          </Col>
                          <Col className="address-col mb-col-50">
                            <label>{item.product_price}</label>
                          </Col>
                        </Row>
                      );
                    })}
                    <Row>
                      <Col className="address-col">
                        {t("ORDER")} {t("AMOUNT")} :
                        <label>
                          {displayField(`${orderInfo?.order_price}`)}
                        </label>
                      </Col>
                      <Col className="address-col">
                        {t("ADDITIONAL") + " " + t("COST")} :
                        <label>
                          {displayField(`${orderInfo?.additional_cost}`)}
                        </label>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="address-col">
                        {t("DISCOUNT")} :
                        <label>
                          {displayField(`${orderInfo?.discount_percent}`)}%
                        </label>
                      </Col>
                      <Col className="address-col">
                        {t("ADDITIONAL") + " " + t("DISCOUNT")} :
                        <label>
                          {displayField(`${orderInfo?.additional_discount}`)}
                        </label>
                      </Col>
                    </Row>

                    <Row>
                      <Col className="address-col">
                        {t("TOTAL") + " " + t("DISCOUNT")} :
                        <label>
                          {displayField(`${orderInfo?.discount_total}`)}
                        </label>
                      </Col>
                      <Col className="address-col">
                        {t("TAX")} :
                        <label>{displayField(`${orderInfo?.order_tax}`)}</label>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="address-col">
                        {t("FINAL") + " " + t("PAYABLE")} :
                        <label>
                          {displayField(`${orderInfo?.order_final_payable}`)}
                        </label>
                      </Col>
                      <Col className="address-col">
                        {t("PAYMENT") + " " + t("MODE")} :
                        <label>
                          {displayField(`${orderInfo?.payment_mode}`)}
                        </label>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="address-col">
                        {t("REMARKS")} :
                        <label>{displayField(`${orderInfo?.remarks}`)}</label>
                      </Col>
                      <Col className="address-col">
                        {t("CUSTOMER") + " " + t("NOTE")} :
                        <label>
                          {displayField(`${orderInfo?.customer_order_note}`)}
                        </label>
                      </Col>
                    </Row>

                    <Row>
                      <Col className="address-col">
                        {t("ASSIGNED") + " " + t("TO")} :
                        <label>
                          {displayField(`${orderInfo?.assigned_to?.name}`)}
                        </label>
                      </Col>
                      <Col className="address-col">
                        {t("SERVICE") + " " + t("DATE")} :
                        <label>
                          {displayDateField(`${orderInfo?.service_date}`)}
                          {isNotEmpty(orderInfo?.service_starts_at)
                            ? " " +
                              t("AT") +
                              " " +
                              displayTimeField(
                                `${orderInfo?.service_date}` +
                                  " " +
                                  `${orderInfo?.service_starts_at}`,
                                false
                              )
                            : null}
                        </label>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="address-col">
                        {t("SERVED") + " " + t("BY")} :
                        <label>
                          {displayField(`${orderInfo?.served_by_detail?.name}`)}
                        </label>
                      </Col>
                      <Col className="address-col">
                        {t("SERVED") + " " + t("AT")} :
                        <label>
                          {displayDateTimeField(`${orderInfo?.served_at}`)}
                        </label>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="address-col">
                        {t("SERVICE") + " " + t("RATING")} :
                        {!isEmptyVal(orderInfo?.service_rating) ? (
                          <label>
                            {displayField(`${orderInfo?.service_rating}`)}{" "}
                            {
                              serviceRatingArr[
                                orderInfo?.service_rating as keyof typeof serviceRatingArr
                              ].label
                            }
                          </label>
                        ) : (
                          <label>
                            {displayField(`${orderInfo?.service_rating}`)}{" "}
                          </label>
                        )}
                      </Col>
                      <Col className="address-col">
                        {t("ORDER") + " " + t("STATUS")} :
                        <label>
                          {
                            orderStatusObj[
                              orderInfo?.order_status as keyof typeof orderStatusObj
                            ].label
                          }
                        </label>
                      </Col>
                    </Row>
                    {orderInfo?.order_status ==
                      orderStatusObj.cancelled.value && (
                      <Row>
                        <Col className="address-col">
                          {t("CANCELLATION") + " " + t("REASON")} :
                          <label>
                            {displayField(
                              `${orderInfo?.order_cancellation_reason}`
                            )}
                          </label>
                        </Col>
                        <Col className="address-col">
                          {t("CANCELLED") + " " + t("AT")} :
                          <label>
                            {displayDateTimeField(`${orderInfo?.cancelled_at}`)}
                          </label>
                        </Col>
                      </Row>
                    )}
                    <Row>
                      <Col className="address-col">
                        {t("SERVICE") + " " + t("TIME")} :
                        <label>
                          {processMinute(
                            isEmptyVal(orderInfo.service_time)
                              ? 0
                              : orderInfo.service_time
                          )}
                        </label>
                      </Col>
                      <Col className="address-col">
                        {t("TOTAL") + " " + t("ITEMS")} :
                        <label>
                          {displayField(`${orderInfo?.order_item_count}`)}
                        </label>
                      </Col>
                    </Row>
                  </div>
                </Content>
              ) : null}
            </Container>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ViewOrder;
